<div class="card mb-3">
    <div class="card-header">
        <h6 class="card-title mb-0">Assinatura de E-mail</h6>
    </div>            
    <div class="card-body">
        <img *ngIf="entity.urlAssinaturaEmail" class="img-fluid" [src]="entity.urlAssinaturaEmail" alt="Assinatura do E-mail">
        <div *ngIf="!entity.urlAssinaturaEmail" class="nenhuma-assinatura-email">Nenhuma assinatura</div>
    </div>
    <div class="card-footer p-2">
        <span class="btn btn-primary btn-file btn-sm mr-2" [class.disabled]="uploader.isUploading">
            <i class="fas fa-pencil-alt"></i> Editar Assinatura
            <input type="file" name="inputFileAssinaturaEmail" #inputFile accept="image/*" ng2FileSelect [uploader]="uploader" [disabled]="uploader.isUploading"/>
        </span>
        <button *ngIf="entity.urlAssinaturaEmail" type="button" class="btn btn-light btn-sm" (click)="delete()">
            <i class="far fa-trash-alt"></i> Remover Assinatura
        </button>
    </div>
</div>